import { createContext, useContext } from "react"

export const ScheduleContext = createContext()

export function useScheduleContext() {
    return useContext(ScheduleContext)
}
